<div
  class="container training-container px-lg-4"
  *ngIf="view$ | async as view"
  data-test="training-container"
>
  <div class="d-none d-lg-flex w-100 justify-content-end py-3">
    <div class="col-2">
      <flo-select-input
        [options]="view.selectOptions"
        [initial]="view.sort"
        [formControl]="view.topSortControl"
      ></flo-select-input>
    </div>
  </div>
  <div class="row">
    <flo-vertical-search
      class="col-md-12 col-lg-3 marg-top mb-3"
      data-test="facet-container"
      [allFacets]="allFacets$ | async"
      [currentFacets]="currentFacets$ | async"
      [resultsCount]="resultsCount$ | async"
      [debounceTime]="750"
      [searchName]="view.searchTitle"
      [totalSuffix]="view.totalTitle"
      [totalSuffixPlural]="view.totalTitlePlural"
      [total]="view.videos?.length"
      [searchTerm]="view.searchTerm"
      (queryChange)="onVertSearchChange($event)"
      queryChangeSkip="1"
      [selectedFacets]="selectedFacets$ | async"
    >
      <div class="mt-2 d-flex d-lg-none">
        <flo-select-input
          [options]="view.selectOptions"
          [initial]="view.sort"
          id="sort"
          [ngModel]="view.sort"
          ngDefaultControl
        >
        </flo-select-input>
      </div>
    </flo-vertical-search>
    <div class="col marg-top">
      <div *ngIf="view.selectedVideo" class="mb-4">
        <div>
          <flo-video-player
            floScrollToElementOnNavigation
            #videoPlayer
            id="video-player"
            [video]="view.selectedVideo?.player"
            [isAutoPlayed]="true"
            [isPlaylist]="true"
            (played)="onPlayed(view.nextVideoId)"
          >
          </flo-video-player>
        </div>
        <div id="desc" class="full-content">
          <h2>{{ view.selectedVideo?.info?.title }}</h2>
          <h3>{{ view.selectedVideo?.info?.date | date }}</h3>
          <div [ngSwitch]="view.selectedVideo?.info?.isRich">
            <p
              id="dynamic-content"
              *ngSwitchCase="true"
              [innerHTML]="view.selectedVideo?.info?.description | floSanitizeHtml"
              floDynamicContent
            ></p>
            <p id="plain-content" *ngSwitchCase="false">{{
              view.selectedVideo?.info?.description
            }}</p>
          </div>
        </div>
        <div *ngIf="view.selectedVideo?.player.node.tags" class="pb-3">
          <flo-tags
            collectionTabUriPart="/video"
            [tags]="view.selectedVideo.player.node.tags"
          ></flo-tags>
        </div>
        <div
          *ngIf="view.selectedVideo?.player.node.tags"
          class="mt-1 pb-2 border-top border-grey-300"
        ></div>
      </div>
      <flo-video-grid
        [videos]="view.videos"
        [notFoundWarning]="view.notFoundWarning"
        queryParamsHandling="merge"
        [queryParamsFn]="view?.queryParamsFn"
        (selectionChange)="emitThumbnailClick$.next(true)"
      ></flo-video-grid>
      <br />
      <div class="d-flex justify-content-center" *ngIf="view.canLoadMore">
        <button
          floAnalytics
          name="See More"
          class="btn-primary btn btn-lg"
          (click)="onPage(view.nextLimit)"
          data-test="result-see-more"
          >See More</button
        >
      </div>
    </div>
  </div>
</div>
